import { localStorageApi } from './storage';

const storageConsent = localStorageApi('consent');
const storageRoute = localStorageApi('route');
const storageOddsFromat = localStorageApi('oddsFormat');
const storageDisabledGames = localStorageApi('disabledGames');

export { storageRoute, storageConsent, storageOddsFromat, storageDisabledGames };
